import EcsConversation from '@/components/ecs-conversation/EcsConversation';

import { MAX_HISTORICAL_CONVERSATIONS } from '@/constants/store/constants';

const createConversation = (state, conversation) => {
  state.conversations = state.conversations.concat([conversation]);
};

const deleteConversation = (state, elementId) => {
  state.conversations = state.conversations.filter(conversation => conversation.elementId !== elementId);
};

const addMessage = (state, { elementId, message }) => {
  const conversationIndex = state.conversations.findIndex(c => c.elementId === elementId);
  if (conversationIndex !== -1) {
    state.conversations[conversationIndex].messages.push(message);
  }
};

const addMessagesToConversation = (state, { elementId, messages }) => {
  const conversation = state.conversations.find(c => c.elementId === elementId);
  if (conversation) {
    conversation.messages = [...conversation.messages, ...messages];
  }
};

const setMessagesToConversation = (state, { elementId, messages }) => {
  const conversation = state.conversations.find(c => c.elementId === elementId);
  if (conversation) {
    conversation.messages = [...messages];
  }
};

const addTypingParticipant = (state, { elementId, originator }) => {
  const conversation = state.conversations.find(c => c.elementId === elementId);
  if (conversation) {
    const participantIndex = conversation.isTyping.findIndex(p => p.id === originator.id);
    if (participantIndex === -1) {
      conversation.isTyping.push(originator);
    }
  }
};

const removeTypingParticipant = (state, { elementId, originator }) => {
  const conversation = state.conversations.find(c => c.elementId === elementId);
  if (!conversation) {
    return;
  }
  conversation.isTyping = conversation.isTyping.filter(person => person.id !== originator.id);
};

const createHistoricalConversation = (state, conversation) => {
  if (conversation) {
    state.history = state.history.concat([conversation]);
    if (state.history.length > MAX_HISTORICAL_CONVERSATIONS) {
      state.history = state.history.slice(-MAX_HISTORICAL_CONVERSATIONS);
    }
  }
};

const deleteHistoricalConversations = (state, elementId) => {
  state.history = state.history.filter(conversation => conversation.elementId !== elementId);
};

const deleteConversationsForInteraction = (state, interactionId) => {
  state.conversations = state.conversations.filter(conversation => conversation.interactionId !== interactionId);
};

const deleteHistoricalConversationsForInteraction = (state, interactionId) => {
  state.history = state.history.filter(conversation => conversation.interactionId !== interactionId);
};

const loadInteractionSmsHistory = (state, { interactionId, messages, elementId }) => {
  const smsMessages = new EcsConversation({
    interactionId,
    messages: messages.sort((x, y) => {
      return new Date(x.timestamp) - new Date(y.timestamp);
    }),
    elementId
  });
  let conversation = state.conversations.find(conversation => conversation.elementId === elementId);
  if (conversation) {
    conversation = { ...smsMessages };
  } else {
    state.conversations.push(smsMessages);
  }
};

export default {
  addMessage,
  addTypingParticipant,
  addMessagesToConversation,
  setMessagesToConversation,
  createConversation,
  deleteConversation,
  removeTypingParticipant,
  createHistoricalConversation,
  deleteHistoricalConversations,
  deleteConversationsForInteraction,
  deleteHistoricalConversationsForInteraction,
  loadInteractionSmsHistory
};
